/*@ngInject*/
const LandingController = function ($scope, $window, $timeout, landingConstant, submissionGridConstant, landingMediator, modalUtil,
                  preferenceModel, currentUserModel, $uibModal, coreMediator, xmlUtil, coreConstant, gridColumnModel,
                  advancedFilterType, widgetType, advancedFilterMediator, browserUtil, appTypeConfigurationModel, filterType) {

    $scope.widgetTemplates = {};
    $scope.upodatedWidgetTemplates = {};
    $scope.widgetTimer = null;
    $scope.submissionFilterUri = null;
    $scope.submissionSortType = null;
    $scope.submissionSortKey = null;
    $scope.taskFilterUri = null;
    $scope.taskSortType = null;
    $scope.taskSortKey = null;
    $scope.submissionGridColumns = null;
    $scope.taskGridColumns = null;
    $scope.gridType = null;
    $scope.activityFilterUri = null;

    function handleResizeStart(event, $element, widget) {
        $scope.$broadcast(coreConstant.event.widget.RESIZE_START, widget);
    }

    function handleResizeStop(event, $element, widget) {
        $scope.$broadcast(coreConstant.event.widget.RESIZE_STOP, widget);
        saveWidgets();
    }

    function handleDragStart(event, $element, widget) {
        $scope.$broadcast(coreConstant.event.widget.DRAG_START, widget);
    }

    function handleDragStop(event, $element, widget) {
        $scope.$broadcast(coreConstant.event.widget.DRAG_STOP, widget);
        saveWidgets();
    }

    function showTermsAndConditions() {
        const termsAndConditionsAcceptedOnLogin = preferenceModel.get('general.copyrightLicense.accepted');

        let allowedTermsAndCondition = {},
            showTermsAndConditions = false;

        if (termsAndConditionsAcceptedOnLogin !== 'true') {
            let userType = currentUserModel.getCurrentUser().userType;
            if (userType === 'Underwriter' || userType === 'ServiceUser') {
                allowedTermsAndCondition = preferenceModel.get('system.allowedTermsAndConditionsCarrierRoles');
            } else if (userType === 'Agent') {
                allowedTermsAndCondition = preferenceModel.get('system.allowedTermsAndConditionsAgencyRoles');
            }

            const roleNameList = allowedTermsAndCondition.split(';');
            _.each(roleNameList, function (roleName) {
                let roleNames = currentUserModel.getCurrentUser().roleNames;
                _.each(roleNames, function (role) {
                    if (role === roleName) {
                        showTermsAndConditions = true;
                        return false;
                    }
                });

                if (showTermsAndConditions) {
                    return false;
                }
            });

            if (showTermsAndConditions) {
                let promise;

                if (appTypeConfigurationModel.isAgentConsole()) {
                    promise = coreMediator.getConfiguredFile('Agency Terms and Conditions');
                } else if (appTypeConfigurationModel.isUnderwriterWorkstation()) {
                    promise = coreMediator.getConfiguredFile('Carrier Terms and Conditions');
                }

                if (!_.isNil(promise)) {
                    promise.then(function (configuredFile) {
                        if (!_.isEmpty(configuredFile) && !_.isNil(configuredFile.fileName) && !_.isNil(configuredFile.size)) {
                            showTermsAndConditionsModal(configuredFile);
                        }
                    });
                }
            }
        }
    }

    function showTermsAndConditionsModal(configuredFile) {
        const modalInstance = $uibModal.open({
            templateUrl: '/landing/termsAndConditions/termsAndConditions.tpl.html',
            controller: 'termsAndConditionsController',
            windowClass: 'termsAndConditionsModal',
            resolve: {
                options: function () {
                    return {
                        configuredFile: configuredFile
                    };
                }
            },
            keyboard: false,
            backdrop: 'static'
        });

        if (browserUtil.isIE11()) {
            modalInstance.result.finally(function () {
                $window.location.reload();
            });
        }
    }

    /**
     * Gridster documentation found here: https://github.com/ManifestWebDesign/angular-gridster
     */
    $scope.gridsterOpts = {
        margins: [20, 20],
        outerMargin: true,
        pushing: true,
        floating: true,
        draggable: {
            enabled: true,
            handle: '.titlebarWidget',
            start: handleDragStart,
            stop: handleDragStop
        },
        resizable: {
            enabled: true,
            handles: ['se'],
            start: handleResizeStart,
            stop: handleResizeStop
        }
    };

    function checkUserWidgetAndFilterSelection() {
        let columns,
            columnsList;
        coreMediator.loadUserPreferences().then(function () {

            landingMediator.loadWidgetLayoutTemplate().then(function (widgetLayoutTemplate) {

                coreMediator.loadUserPreferences().then(function () {

                    let widgetsObject = xmlUtil.parseStringWithoutFlattening(preferenceModel.get('view.widgets')),
                        widgetArray;

                    _.each(widgetLayoutTemplate.widgetTemplates, function (widgetTemplate) {
                        if (widgetTemplate.options) {
                            widgetTemplate.options = JSON.parse(widgetTemplate.options);
                        }
                    });

                    if (widgetsObject.widgets) {
                        _.each(widgetLayoutTemplate.widgetTemplates, function (widgetTemplate) {
                            widgetArray = Array.isArray(widgetsObject.widgets.widget) ? widgetsObject.widgets.widget : [widgetsObject.widgets.widget];
                            if (widgetArray) {
                                _.each(widgetArray, function (item) {
                                    if (widgetTemplate.type === parseInt(item.type)) {
                                        widgetTemplate.sizeX = parseInt(item.sizeX);
                                        widgetTemplate.sizeY = parseInt(item.sizeY);
                                        widgetTemplate.row = parseInt(item.row);
                                        widgetTemplate.col = parseInt(item.col);

                                        if (widgetTemplate.type === 1) {
                                            if (item.filterUri) {
                                                advancedFilterMediator.getFilter(item.filterUri).then(function (filter) {
                                                    if (filter !== '' && !_.isNil(filter)) {
                                                        $scope.submissionFilterUri = item.filterUri;
                                                        gridColumnModel.updateSubmissionParamByName('filterUri', item.filterUri);
                                                        gridColumnModel.setSavedFilterUri(advancedFilterType.SUBMISSION_GRID, item.filterUri);
                                                    }
                                                }.bind(this));
                                            }

                                            if (item.sortType) {
                                                gridColumnModel.updateSubmissionParamByName('sortType', item.sortType);
                                                gridColumnModel.updateSubmissionParamByName('key', item.sortKey);
                                            }

                                            if (!_.isNil(item.columns)) {
                                                columns = '<columns>';
                                                columnsList = item.columns;
                                                _.each(columnsList.column, function (data) {
                                                    let column = '<column visible=' + '"' + data._visible + '"' + ' width=' + '"' + data._width + '"' + ' accessor=' + '"' + data._accessor + '"';
                                                    if (_.isNil(data._type) && !_.isNil(data._sort)) {
                                                        column += ' sort=' + '"' + data._sort + '"';
                                                    } else if (!_.isNil(data._type) && _.isNil(data._sort)) {
                                                        column += ' type=' + '"' + data._type + '"';
                                                    } else if (!_.isNil(data._type) && !_.isNil(data._sort)) {
                                                        column += ' type=' + '"' + data._type + '"' + ' sort=' + '"' + data._sort + '"';
                                                    }
                                                    column += '>' + data.__text + '</column>';
                                                    columns += column;
                                                });
                                                columns += '</columns>';
                                                // not to use view.widgets columns for submissionGrid anymore
                                                //$scope.submissionGridColumns = columns;
                                            }

                                        }

                                        if (widgetTemplate.type === 2) {
                                            if (item.filterUri) {
                                                advancedFilterMediator.getFilter(item.filterUri).then(function (filter) {
                                                    if (filter !== '' && !_.isNil(filter)) {
                                                        $scope.taskFilterUri = item.filterUri;
                                                        gridColumnModel.updateTaskParamByName('filterUri', item.filterUri);
                                                        gridColumnModel.setSavedFilterUri(advancedFilterType.TASK_GRID, item.filterUri);
                                                    }
                                                }.bind(this));
                                            }

                                            if (item.sortType) {
                                                gridColumnModel.updateTaskParamByName('sortType', item.sortType);
                                                gridColumnModel.updateTaskParamByName('key', item.sortKey);
                                            }

                                            if (!_.isNil(item.columns)) {
                                                columns = '<columns>';
                                                columnsList = item.columns;
                                                _.each(columnsList.column, function (data) {
                                                    let column = '<column visible=' + '"' + data._visible + '"' + ' width=' + '"' + data._width + '"' + '>' + data.__text + '</column>';
                                                    columns += column;
                                                });
                                                columns += '</columns>';
                                                $scope.taskGridColumns = columns;
                                            }

                                        }
                                        if (widgetTemplate.type === 4) {
                                            if (item.filterUri) {
                                                advancedFilterMediator.getFilter(item.filterUri).then((filter) => {
                                                    if (!_.isEmpty(filter)) {
                                                        $scope.activityFilterUri = item.filterUri;
                                                        gridColumnModel.updateActivityParamByName('filterUri', item.filterUri);
                                                        gridColumnModel.setSavedFilterUri(advancedFilterType.ACTIVITY_GRID, item.filterUri);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }.bind(this));
                            }
                        }.bind(this));
                    }

                    $scope.widgetTemplates = widgetLayoutTemplate.widgetTemplates;
                    $scope.$watch('widgetTemplates', function (items) {
                        $scope.upodatedWidgetTemplates = items;
                    }, true);
                }.bind(this));

            });
        });
    }

    $scope.$on(coreConstant.event.widget.RESIZE_STOP, function () {
        $timeout.cancel($scope.widgetTimer);
        $scope.widgetTimer = $timeout(function () {
            saveWidgets();
        }, 1000);
    });

    function saveWidgets() {
        $timeout.cancel($scope.widgetTimer);
        let value = getWidgetsXML($scope.upodatedWidgetTemplates);
        coreMediator.updateUserPreferences('view.widgets', value);
    }

    function saveUserWidget(type) {
        // update filter-specific user preference
        if (type==widgetType.SUBMISSIONS) {
          let filterUri = $scope.submissionFilterUri;
          if (!filterUri) {
            filterUri = gridColumnModel.getSubmissionParams().filterUri;
          }
          let prefName = "views."+$scope.gridType+":"+filterUri;
          let item = findWidgetOfType($scope.upodatedWidgetTemplates, 1);
          let widgetXML = getWidgetXML(item);
          coreMediator.updateUserPreferences(prefName, widgetXML).then(function () {});
      }
    }

    function saveColumnPreferences() {
        let value;
        coreMediator.loadUserPreferences().then(function () {
            value = getWidgetsXML($scope.upodatedWidgetTemplates);
            coreMediator.updateUserPreferences('view.widgets', value).then(function () {
              $scope.widgetTimer = $timeout(function () {
                    $scope.$broadcast(submissionGridConstant.event.RESET_GRID_COLUMNS, $scope.gridType);
              }, 500);
            });
        });
    }

    $scope.$on(coreConstant.event.FILTER_CHANGED, function (event, filterUri, filterType) {

        if (filterType === advancedFilterType.SUBMISSION_GRID) {
            $scope.submissionFilterUri = filterUri;
            saveWidgets();
        }

        if (filterType === advancedFilterType.TASK_GRID) {
            $scope.taskFilterUri = filterUri;
            saveWidgets();
        }

        if (filterType === advancedFilterType.ACTIVITY_GRID) {
            $scope.activityFilterUri = filterUri;
            saveWidgets();
        }


    }.bind(this));

    $scope.$on(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, function (event, gridPreference, columns, doSave=true) {
        if (gridPreference === 'view.agent.homePageColumns' || gridPreference === 'view.uw.homePageColumns') {
            $scope.submissionGridColumns = columns;
            $scope.gridType = 'submissionGrid';
            if (doSave) {
            	saveUserWidget(widgetType.SUBMISSIONS);
			}
        } else {
            if (gridPreference === 'view.tasksHomePageTaskColumnsForUnderwriter' || gridPreference === 'view.tasksHomePageTaskColumnsForAgent') {
                $scope.taskGridColumns = columns;
                $scope.gridType = 'taskGrid';
            }
        }
        if (doSave) {
	        // the old whole landing page "view.widgets" preference
	        saveColumnPreferences();
		}
    }.bind(this));

    $scope.$on(coreConstant.event.GRID_SORT_TYPE_CHANGED, function (event, params, filterType) {

        if (filterType === advancedFilterType.SUBMISSION_GRID) {
            $scope.submissionSortType = params.sortType;
            $scope.submissionSortKey = params.key;
            $scope.gridType = 'submissionGrid';
            saveUserWidget(1);
            saveWidgets();
        }

        if (filterType === advancedFilterType.TASK_GRID) {
            $scope.taskSortType = params.sortType;
            $scope.taskSortKey = params.key;
            saveWidgets();
        }

    }.bind(this));

    function getWidgetXML(item) {
        let xmlWidget = '<widget>';
        xmlWidget += '<sizeX>' + item.sizeX + '</sizeX>';
        xmlWidget += '<sizeY>' + item.sizeY + '</sizeY>';
        xmlWidget += '<row>' + item.row + '</row>';
        xmlWidget += '<col>' + item.col + '</col>';
        xmlWidget += '<type>' + item.type + '</type>';

        if (parseInt(item.type) === 1) {
            if (!_.isNil($scope.submissionFilterUri)) {
                xmlWidget += '<filterUri>' + $scope.submissionFilterUri + '</filterUri>';
            }

            if (!_.isNil($scope.submissionSortType)) {
                xmlWidget += '<sortType>' + $scope.submissionSortType + '</sortType>';
                xmlWidget += '<sortKey>' + $scope.submissionSortKey + '</sortKey>';
            }

            if (!_.isNil($scope.submissionGridColumns)) {
                xmlWidget += $scope.submissionGridColumns;
            }
        }

        if (parseInt(item.type) === 2) {
            if (!_.isNil($scope.taskFilterUri)) {
                xmlWidget += '<filterUri>' + $scope.taskFilterUri + '</filterUri>';
            }

            if (!_.isNil($scope.taskSortType)) {
                xmlWidget += '<sortType>' + $scope.taskSortType + '</sortType>';
                xmlWidget += '<sortKey>' + $scope.taskSortKey + '</sortKey>';
            }

            if (!_.isNil($scope.taskGridColumns)) {
                xmlWidget += $scope.taskGridColumns;
            }
        }

        if (parseInt(item.type) === 4) {
            if (!_.isNil($scope.activityFilterUri)) {
                xmlWidget += '<filterUri>' + $scope.activityFilterUri + '</filterUri>';
            }
        }

        xmlWidget += '</widget>';

        return xmlWidget;
    }

    function getWidgetsXML(items) {
        let xmlWidget = '<widgets>';
        _.each(items, function (item) {
          xmlWidget += getWidgetXML(item)
        });
        xmlWidget += '</widgets>';
        return xmlWidget;
    }

    function findWidgetOfType(items, type) {
    let result = null;
        _.each(items, function (item) {
          if (item.type==type)
            result = item;
        });
        return result;
    }

    $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
        gridColumnModel.reset();
    }.bind(this));

    showTermsAndConditions();
    checkUserWidgetAndFilterSelection();
};

angular.module('umLanding')
    .controller('landingController', LandingController);
